import { TranslationRegions, ValidRegions } from "@/components/types";
import { Customer } from "@endavaaccorplus/payments-common/schemas";

export const translationKeyToLocaleMap = {
  au: "en-AU",
  kr: "ko-KR",
  th: "th-TH",
  vn: "vi-VN",
  id: "id-ID",
  ja: "ja-JP",
} as const satisfies Record<ValidRegions, string>;

export const translationKeyToLocalLanguageMap = {
  au: "en",
  kr: "ko",
  th: "th",
  vn: "vi",
  id: "id",
  ja: "ja",
} as const satisfies Record<ValidRegions, Customer["preferredLanguage"]>;

export const getLanguage = (translationKey: TranslationRegions) =>
  translationKeyToLocalLanguageMap[
    translationKey as keyof typeof translationKeyToLocalLanguageMap
  ] ?? "en";

export const getTranslationKeyFromWordpressLang = (lang?: string) =>
  lang
    ? (getTranslationKeyFromLanguageCode(
        lang as Customer["preferredLanguage"],
      ) ?? "en")
    : "en";

export const getTranslationKeyFromLanguageCode = (
  languageCode: Customer["preferredLanguage"],
) => {
  if (languageCode === "en") return languageCode as TranslationRegions;
  return Object.fromEntries(
    Object.entries(translationKeyToLocalLanguageMap).map(([k, v]) => [v, k]),
  )[languageCode] as TranslationRegions;
};

export const getLocaleCode = (
  translationKey?: string,
):
  | (typeof translationKeyToLocaleMap)[keyof typeof translationKeyToLocaleMap]
  | "en" => {
  return translationKeyToLocaleMap[translationKey as ValidRegions] ?? "en";
};
